import React from "react"
import Flex from "typescript-styled-flex"
import { useTranslation } from "react-i18next"
import Expander from "../Expander"
import Text, { HeaderText } from "../Text"
import useFormatDate from "../../../hooks/useFormatDate"
import { useFormatTime } from "../../../hooks/useFormatTime"
import { subHours } from "date-fns"

export default function(notification, size = 1) {
  const { t } = useTranslation()
  const dateFormat = useFormatDate()
  const timeFormat = useFormatTime()

  return (
    <Expander size={size} id={notification.id}>
      <Text size={size}>
        <HeaderText size={size}>{notification.subtitle}</HeaderText>
        <Flex column={true}>
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            {`${t('BBO_930_synchronization_start_date')}: `}
            <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
              &nbsp;{dateFormat(subHours(notification.details.startDate, new Date().getTimezoneOffset() / 60))}
              &nbsp;
              {timeFormat(subHours(notification.details.startDate, new Date().getTimezoneOffset() / 60))}
            </div>
          </div>
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: `${5 * size}px`,
            }}
          >
            {`${t('BBO_930_synchronization_end_date')}: `}
            <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
              {' '}
              &nbsp;
              {notification.details.endDate
                ? `${dateFormat(subHours(notification.details.endDate, new Date().getTimezoneOffset()/60))} ${timeFormat(
                    subHours(notification.details.endDate, new Date().getTimezoneOffset() / 60),
                  )}`
                : ''}
            </div>
          </div>
        </Flex>
      </Text>
    </Expander>
  )
}
